import { render, staticRenderFns } from "./ConvenioDetalhar.vue?vue&type=template&id=5508f2b1"
import script from "./ConvenioDetalhar.vue?vue&type=script&lang=js"
export * from "./ConvenioDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports